import { Menu, type MenuProps } from 'antd';
import React from 'react';

import './styles.less';

type Props = Pick<MenuProps, 'items' | 'selectable' | 'onClick' | 'style'> & {
  selectedKey: string; // Overriding the 'selectedKeys' prop from MenuProps type.
};

/**
 * A wrapper around the antd Menu with our custom config applied.
 * For use in main navigation side menus.
 */
function MainNavigationMenu({
  selectable,
  selectedKey,
  onClick,
  items
}: Props): JSX.Element {
  return (
    <Menu
      className="MainNavigationMenu"
      selectable={selectable}
      mode="inline"
      selectedKeys={[selectedKey]}
      onClick={onClick}
      inlineIndent={27}
      items={items}
    />
  );
}

export default MainNavigationMenu;
